import { Route, Routes } from 'react-router-dom';

// Analysis pages
import { AnalysisProductsPage } from '@/pages/AnalysisProductsPage';
import { AnalysisPublicPage } from '@/pages/AnalysisPublicPage';
import { AnalysisVendorsPage } from '@/pages/AnalysisVendorsPage';
import { ContactPage } from '@/pages/ContactPage';
import { HomePage } from '@/pages/HomePage';
import { ManageUserAccountPage } from '@/pages/ManageUserAccount';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { SignInPage } from '@/pages/SignIn';
import { SignUpPage } from '@/pages/SignUp';
import { SubscriptionPage } from '@/pages/SubscriptionPage';
import { TestThemePage } from '@/pages/TestThemePage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route path="/manage-user-account/*" element={<ManageUserAccountPage />} />
      <Route path="/test-theme" element={<TestThemePage />} />
      <Route path="/subscription" element={<SubscriptionPage />} />
      <Route path="/contact" element={<ContactPage />} />

      {/* Analysis routes - le même composant gère la liste et le détail */}
      <Route path="/analysis/products" element={<AnalysisProductsPage />} />
      <Route path="/analysis/products/:id" element={<AnalysisProductsPage />} />
      <Route path="/analysis/products/:id/tab/:tab" element={<AnalysisProductsPage />} />
      <Route path="/analysis/vendors" element={<AnalysisVendorsPage />} />
      <Route path="/analysis/vendors/:id" element={<AnalysisVendorsPage />} />
      <Route path="/analysis/vendors/:id/tab/:tab" element={<AnalysisVendorsPage />} />
      <Route path="/analysis/public" element={<AnalysisPublicPage />} />
      <Route path="/analysis/public/:id" element={<AnalysisPublicPage />} />
      <Route path="/analysis/public/:id/tab/:tab" element={<AnalysisPublicPage />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
